import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "tab-item-label" }
const _hoisted_3 = { class: "tab-item-label" }

import { Tab } from '@/types/tabs';
import useCustomIcon from '@/utilities/composables/useCustomIcon';
import { computed, ref } from 'vue';
import constants from '@/utilities/constants';
import { useRouter } from 'vue-router';
import FilterDropdown from '@/components/widgets/filters/FilterDropdown';


export default /*@__PURE__*/_defineComponent({
  __name: 'SingleTab',
  props: {
    tab: {},
    dropdownForTab: {},
    tabClickCount: {}
  },
  emits: ['click-dropdown-item', 'closeDropdown'],
  setup(__props: any, { emit: __emit }) {

const router = useRouter();
const emit = __emit;

const props = __props;

const bodyRef = ref(document.body);
const searchQuery = ref('');

const { iconPath, getCustomIconStyle } = useCustomIcon();

const showDropdown = computed(() => {
  return props.dropdownForTab === props.tab.id;
});

const openDropdownOptions = computed(() => {
  return props.tab.selected && (props?.tabClickCount || 0) >= 1;
});

const selectedItemCheck = computed(() => {
  // Prevent showing check icon for selected item that shows when searching
  return searchQuery.value ? -1 : props.tab.dropdownOptions.selectedItem;
});

const handleOnHideDropdown = () => {
  searchQuery.value = '';
};

const handleDropdownItemClick = (hide, template) => {
  if (template) props.tab.dropdownOptions.clickFn(template);

  hide?.();
  emit('click-dropdown-item');
};

const getDropdownItems = (hide) => {
  return props.tab.dropdownOptions.items.reduce((acc, item) => {
    if (item.label.toLowerCase().includes(searchQuery.value.toLowerCase())) {
      acc.push({
        ...item,
        ...(item.additionalRightIconCallback && {
          additionalRightIconCallback: () => {
            item.additionalRightIconCallback();
            handleDropdownItemClick(hide);
          },
        }),
      });
    }
    return acc;
  }, []);
};

const handleFooterClick = ($event) => {
  const { note: noteTemplate } = constants.settingsTemplate;
  router.push({ name: noteTemplate.root.name });
  emit('closeDropdown', $event);
};

const handleQueryChange = (query) => {
  searchQuery.value = query;
};

return (_ctx: any,_cache: any) => {
  const _component_v_popover = _resolveComponent("v-popover")!

  return (showDropdown.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_popover, {
          interactive: "",
          tag: "div",
          "content-tag": "div",
          trigger: 'click',
          role: 'poper',
          class: "tab-dropdown",
          "on-show": () => openDropdownOptions.value,
          "on-hide": handleOnHideDropdown,
          placement: 'bottom-start',
          "append-to": bodyRef.value
        }, {
          content: _withCtx(({ state, hide }) => [
            (state.isVisible)
              ? (_openBlock(), _createBlock(_unref(FilterDropdown), {
                  key: 0,
                  class: "tab-list-dropdown",
                  title: _ctx.tab.dropdownOptions.title,
                  placeholder: _ctx.tab.dropdownOptions.searchPlaceholder,
                  "search-results": getDropdownItems(hide),
                  "dropdown-footer": true,
                  "footer-text": _ctx.tab.dropdownOptions.footerText,
                  "on-item-click": (template) => handleDropdownItemClick(hide, template),
                  "on-item-right-side-click": (template) => handleDropdownItemClick(hide, template),
                  "selected-item-check": selectedItemCheck.value,
                  "scroll-to-selected": true,
                  "hide-filter-popup": () => {},
                  onEsc: hide,
                  onFooterClick: handleFooterClick,
                  onQueryChange: handleQueryChange
                }, null, 8, ["title", "placeholder", "search-results", "footer-text", "on-item-click", "on-item-right-side-click", "selected-item-check", "onEsc"]))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["tab-item h-[22px]", { selected: _ctx.tab.selected }])
            }, [
              (_ctx.tab.icon)
                ? (_openBlock(), _createElementBlock("em", {
                    key: 0,
                    class: "tab-item-icon custom-icons",
                    style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)(_ctx.tab.icon)))
                  }, null, 4))
                : _createCommentVNode("", true),
              _cache[0] || (_cache[0] = _createTextVNode()),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.tab.label), 1),
              _cache[1] || (_cache[1] = _createTextVNode()),
              (_ctx.tab.selected)
                ? (_openBlock(), _createElementBlock("em", {
                    key: 1,
                    class: "custom-icons ml-2",
                    style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)('chevron-down')))
                  }, null, 4))
                : _createCommentVNode("", true),
              _cache[2] || (_cache[2] = _createTextVNode()),
              (_ctx.tab.hasSlot)
                ? _renderSlot(_ctx.$slots, "default", { key: 2 })
                : _createCommentVNode("", true)
            ], 2),
            _cache[3] || (_cache[3] = _createTextVNode())
          ]),
          _: 3
        }, 8, ["on-show", "append-to"])
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["tab-item h-full", { selected: _ctx.tab.selected }])
      }, [
        (_ctx.tab.icon)
          ? (_openBlock(), _createElementBlock("em", {
              key: 0,
              class: "tab-item-icon custom-icons",
              style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)(_ctx.tab.icon)))
            }, null, 4))
          : _createCommentVNode("", true),
        _cache[4] || (_cache[4] = _createTextVNode()),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.tab.label), 1),
        _cache[5] || (_cache[5] = _createTextVNode()),
        (_ctx.tab.hasSlot)
          ? _renderSlot(_ctx.$slots, "default", { key: 1 })
          : _createCommentVNode("", true)
      ], 2))
}
}

})